export const GET_ACCOUNT_SUCCESS = "GET_ACCOUNT_SUCCESS";
export const GET_ACCOUNT_FAIL = "GET_ACCOUNT_FAIL";
export const GET_ACCOUNT_REQUEST = "GET_ACCOUNT_REQUEST";
export const GET_ALL_ACCOUNT_SUCCESS = "GET_ALL_ACCOUNT_SUCCESS";
export const GET_ALL_ACCOUNT_FAIL = "GET_ALL_ACCOUNT_FAIL";
export const GET_ALL_ACCOUNT_REQUEST = "GET_ALL_ACCOUNT_REQUEST";
export const GET_ACCOUNT_UPDATE_SUCCESS = "GET_ACCOUNT_UPDATE_SUCCESS";
export const GET_ACCOUNT_UPDATE_FAIL = "GET_ACCOUNT_UPDATE_FAIL";
export const GET_ACCOUNT_UPDATE_REQUEST = "GET_ACCOUNT_UPDATE_REQUEST";
export const GET_ACCOUNT_DELETE_SUCCESS = "GET_ACCOUNT_DELETE_SUCCESS";
export const GET_ACCOUNT_DELETE_FAIL = "GET_ACCOUNT_DELETE_FAIL";
export const GET_ACCOUNT_DELETE_REQUEST = "GET_ACCOUNT_DELETE_REQUEST";

